/**
 * 1등급 개인정보 처리방침 — 학부모용 / 학원용 분기
 * 라우트: /app/privacy/:role  (role = 'parent' | 'academy')
 */
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import styled from 'styled-components';
import { IoChevronBack } from 'react-icons/io5';

const COMPANY = '주식회사 홍컴즈';
const SERVICE = '1등급';
const CONTACT = 'kkan2222@gmail.com';
const EFFECTIVE = '2026년 5월 23일';

const PARENT_PRIVACY = [
  {
    h: '제1조 (총칙)',
    p: [
      `${COMPANY}(이하 "회사")는 학부모 회원 및 자녀의 개인정보를 소중히 다루며, 「개인정보 보호법」 등 관련 법령을 준수합니다. 본 처리방침은 ${SERVICE} 서비스(이하 "서비스")를 이용하는 학부모 회원에게 적용됩니다.`,
    ],
  },
  {
    h: '제2조 (수집하는 개인정보 항목 및 수집 방법)',
    p: [
      '1. 회원가입·서비스 이용 과정에서 다음의 정보를 수집합니다.',
      '가. 필수: 이름(또는 닉네임), 휴대전화번호, 이메일 주소(소셜 로그인 시 카카오·구글 계정 정보)',
      '나. 선택: 프로필 사진, 거주 지역',
      '다. 자녀 정보(선택): 자녀 이름, 생년, 학년, 사진',
      '2. 서비스 이용 중 자동으로 다음 정보가 수집될 수 있습니다.',
      '가. 단말 정보(OS, 모델명), 접속 IP, 접속 로그, 쿠키, 푸시 토큰',
      '3. 학원에 수강 신청·문의를 한 경우, 회원이 입력·동의한 정보(자녀 정보·메시지 내용 등)가 해당 학원에 제공됩니다.',
    ],
  },
  {
    h: '제3조 (개인정보의 처리 목적)',
    p: [
      '1. 회원 식별 및 본인 확인',
      '2. 학원 검색·수강 신청·자녀 등록 등 서비스 제공',
      '3. 학원과의 채팅·알림장·공지 전달',
      '4. 푸시 알림, 공지사항 등 서비스 안내',
      '5. 부정 이용 방지, 분쟁 처리, 민원 응대',
      '6. 서비스 개선을 위한 통계 분석(개인 식별 불가능한 형태로 처리)',
    ],
  },
  {
    h: '제4조 (개인정보의 보유 및 이용 기간)',
    p: [
      '1. 회사는 회원이 서비스를 이용하는 기간 동안 개인정보를 보유·이용합니다.',
      '2. 회원 탈퇴 시 지체 없이 파기합니다. 다만, 관련 법령에 따라 일정 기간 보관이 필요한 경우 해당 기간 동안 보관합니다.',
      '가. 계약 또는 청약철회 등에 관한 기록: 5년 (전자상거래법)',
      '나. 대금결제 및 재화 등의 공급에 관한 기록: 5년 (전자상거래법)',
      '다. 소비자의 불만 또는 분쟁처리에 관한 기록: 3년 (전자상거래법)',
      '라. 접속 로그·접속 IP 기록: 3개월 (통신비밀보호법)',
      '3. 1년간 서비스 이용 기록이 없는 회원의 정보는 별도 보관되며, 해당 회원에게 사전 통지 후 분리·파기됩니다.',
    ],
  },
  {
    h: '제5조 (만 14세 미만 아동의 개인정보)',
    p: [
      '1. 회사는 만 14세 미만 아동의 회원가입을 받지 않습니다.',
      '2. 학부모 회원이 자녀(만 14세 미만 포함)의 정보를 등록할 경우, 학부모의 동의를 자녀 본인의 동의로 갈음합니다.',
      '3. 학부모는 자녀 정보에 대해 언제든지 열람·수정·삭제를 요청할 수 있으며, 회사는 지체 없이 이에 응합니다.',
    ],
  },
  {
    h: '제6조 (개인정보의 제3자 제공)',
    p: [
      '1. 회사는 회원의 개인정보를 본 방침에 명시한 범위 내에서만 처리하며, 회원의 동의 없이 제3자에게 제공하지 않습니다. 다만, 다음의 경우는 예외로 합니다.',
      '가. 회원이 학원에 수강 신청·문의를 한 경우, 회원이 동의한 자녀 정보·연락처가 해당 학원에 제공됩니다.',
      '나. 법령에 근거하거나 수사기관이 적법한 절차에 따라 요구한 경우',
      '2. 학원에 제공되는 정보의 범위는 자녀 이름·생년·연락처·메시지 내용 등이며, 제공 시점에 회원에게 별도 안내됩니다.',
    ],
  },
  {
    h: '제7조 (개인정보 처리의 위탁)',
    p: [
      '회사는 서비스 운영을 위해 다음과 같이 개인정보 처리 업무를 위탁할 수 있습니다.',
      '· Google LLC (Firebase): 회원 인증·데이터 저장·푸시 알림 발송',
      '· 카카오 주식회사: 카카오 로그인 처리',
      '· (주)다날, 토스페이먼츠 등 결제·본인인증 사업자: 본인 확인 및 결제 처리(이용 시)',
      '위탁 받은 자는 위탁 목적 외 개인정보를 이용할 수 없으며, 위·수탁 관계 변경 시 본 방침에 반영합니다.',
    ],
  },
  {
    h: '제8조 (회원의 권리와 행사 방법)',
    p: [
      '1. 회원과 법정대리인은 언제든지 다음의 권리를 행사할 수 있습니다.',
      '가. 개인정보 열람 요구',
      '나. 오류 등이 있을 경우 정정 요구',
      '다. 삭제 요구',
      '라. 처리 정지 요구',
      `2. 위 권리는 서비스 내 마이페이지에서 직접 행사하거나, ${CONTACT}로 요청하실 수 있으며, 회사는 지체 없이 조치합니다.`,
    ],
  },
  {
    h: '제9조 (개인정보의 파기)',
    p: [
      '1. 회사는 개인정보 보유 기간이 경과하거나 처리 목적이 달성된 경우 지체 없이 해당 정보를 파기합니다.',
      '2. 전자적 파일은 복구가 불가능한 방법으로 영구 삭제하며, 종이 문서는 분쇄하거나 소각합니다.',
    ],
  },
  {
    h: '제10조 (개인정보의 안전성 확보 조치)',
    p: [
      '1. 비밀번호 등 중요 정보의 암호화 저장',
      '2. 개인정보 처리시스템 접근 권한의 최소화 및 접근 통제',
      '3. 접속 기록의 보관 및 위·변조 방지',
      '4. 백신·방화벽 등 보안 프로그램 운영',
    ],
  },
  {
    h: '제11조 (개인정보 보호책임자)',
    p: [
      '회사는 개인정보 처리에 관한 업무를 총괄하고, 회원의 불만 처리 및 피해 구제를 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.',
      `· 이름: 이행렬`,
      `· 직책: 대표`,
      `· 연락처: ${CONTACT}`,
    ],
  },
  {
    h: '제12조 (개인정보 처리방침의 변경)',
    p: [
      '본 방침은 법령·서비스 변경에 따라 개정될 수 있으며, 변경 사항은 서비스 내 공지를 통해 시행 7일 전부터 안내합니다. 회원에게 불리한 변경은 시행 30일 전부터 안내합니다.',
    ],
  },
];

const ACADEMY_PRIVACY = [
  {
    h: '제1조 (총칙)',
    p: [
      `${COMPANY}(이하 "회사")는 학원 회원의 개인정보 및 학원이 ${SERVICE} 서비스(이하 "서비스")를 통해 처리하는 학부모·자녀 정보를 안전하게 관리하며, 「개인정보 보호법」 등 관련 법령을 준수합니다.`,
    ],
  },
  {
    h: '제2조 (수집하는 개인정보 항목 및 수집 방법)',
    p: [
      '1. 회사는 학원 회원의 가입·서비스 이용 과정에서 다음 정보를 수집합니다.',
      '가. 필수: 대표자명, 학원명, 휴대전화번호, 이메일, 학원 주소, 사업자등록번호(법인의 경우 법인등록번호)',
      '나. 선택: 학원 사진, 강사 정보, 홍보 자료, 정산 계좌 정보',
      '다. 자동수집: 접속 IP, 접속 로그, 단말 정보, 푸시 토큰',
      '2. 학원 회원이 서비스에 직접 입력·등록한 자료(공지·수강료·시간표 등)도 함께 처리됩니다.',
    ],
  },
  {
    h: '제3조 (개인정보의 처리 목적)',
    p: [
      '1. 학원 회원 가입·본인 확인·학원 실재 여부 확인',
      '2. 학원 정보 노출, 수강 신청·문의 응대 등 서비스 제공',
      '3. 학부모 회원과의 채팅·공지·알림장 발송 기능 제공',
      '4. 결제·정산 연동(이용 시), 세금계산서 발행 등 거래 처리',
      '5. 부정 이용 방지, 분쟁 대응, 민원 응대',
      '6. 서비스 개선을 위한 통계 분석',
    ],
  },
  {
    h: '제4조 (학부모 회원·자녀 정보의 취급)',
    p: [
      '1. 학원 회원이 서비스에서 열람·수신하는 학부모·자녀 정보는 학부모 회원이 자발적으로 학원에 제공한 정보로, 학원 회원은 해당 정보의 "개인정보처리자"로서 「개인정보 보호법」상 책임을 부담합니다.',
      '2. 학원 회원은 해당 정보를 학원 운영(수강 관리·연락·결제 등) 목적 외로 사용할 수 없으며, 제3자에게 제공·공개해서는 안 됩니다.',
      '3. 학원 회원이 위 의무를 위반하여 발생한 손해에 대한 책임은 학원 회원에게 있으며, 회사는 위반 사실 확인 시 서비스 이용 제한 등의 조치를 취할 수 있습니다.',
    ],
  },
  {
    h: '제5조 (개인정보의 보유 및 이용 기간)',
    p: [
      '1. 회사는 학원 회원이 서비스를 이용하는 기간 동안 개인정보를 보유·이용합니다.',
      '2. 탈퇴 시 학원 회원의 개인정보는 지체 없이 파기합니다. 다만, 관련 법령에 따라 일정 기간 보관이 필요한 경우 해당 기간 동안 보관합니다.',
      '가. 계약 또는 청약철회 등에 관한 기록: 5년 (전자상거래법)',
      '나. 대금결제 및 재화 등의 공급에 관한 기록: 5년 (전자상거래법)',
      '다. 세금계산서 등 거래 증빙: 5년 (국세기본법)',
      '라. 접속 로그·접속 IP 기록: 3개월 (통신비밀보호법)',
    ],
  },
  {
    h: '제6조 (개인정보의 제3자 제공)',
    p: [
      '1. 회사는 학원 회원의 개인정보를 본 방침에 명시한 범위 내에서만 처리하며, 학원 회원의 동의 없이 제3자에게 제공하지 않습니다. 다만, 다음의 경우는 예외로 합니다.',
      '가. 학부모 회원이 학원 상세 정보를 열람할 때 노출되는 정보(학원명·주소·연락처·대표자명·강사·수강료 등). 이는 서비스의 본질적 기능이며 가입 시 동의로 갈음합니다.',
      '나. 법령에 근거하거나 수사기관이 적법한 절차에 따라 요구한 경우',
    ],
  },
  {
    h: '제7조 (개인정보 처리의 위탁)',
    p: [
      '회사는 서비스 운영을 위해 다음과 같이 처리 업무를 위탁할 수 있습니다.',
      '· Google LLC (Firebase): 데이터 저장, 인증, 푸시 알림 발송',
      '· 카카오 주식회사: 알림톡 발송 (이용 시)',
      '· 결제·정산 사업자(이노페이 등): 결제·정산 연동 (이용 시)',
      '위탁 관계 변경 시 본 방침에 반영합니다.',
    ],
  },
  {
    h: '제8조 (학원 회원의 권리와 행사 방법)',
    p: [
      '1. 학원 회원은 자신의 개인정보에 대해 열람·정정·삭제·처리정지를 요구할 수 있습니다.',
      `2. 권리 행사는 서비스 내 메뉴 또는 ${CONTACT}로 요청할 수 있으며, 회사는 지체 없이 조치합니다.`,
      '3. 학원 회원이 보유한 학부모·자녀 정보에 대한 권리 요구는 해당 학부모 회원이 학원 회원에게 직접 행사하며, 회사는 중개자로서 합리적 범위 내에서 협조합니다.',
    ],
  },
  {
    h: '제9조 (개인정보의 파기)',
    p: [
      '1. 보유 기간 경과·처리 목적 달성 시 지체 없이 파기합니다.',
      '2. 전자적 파일은 복구 불가능한 방식으로 영구 삭제하며, 종이 문서는 분쇄·소각합니다.',
    ],
  },
  {
    h: '제10조 (개인정보의 안전성 확보 조치)',
    p: [
      '1. 비밀번호 등 중요 정보의 암호화 저장 및 전송',
      '2. 개인정보 처리시스템 접근 권한의 최소화 및 접근 통제',
      '3. 접속 기록의 보관(최소 6개월) 및 위·변조 방지',
      '4. 보안 프로그램 운영, 정기적 취약점 점검',
    ],
  },
  {
    h: '제11조 (개인정보 보호책임자)',
    p: [
      '회사는 개인정보 처리에 관한 업무를 총괄하며, 학원 회원의 불만 처리 및 피해 구제를 위하여 아래와 같이 책임자를 지정합니다.',
      `· 이름: 이행렬`,
      `· 직책: 대표`,
      `· 연락처: ${CONTACT}`,
    ],
  },
  {
    h: '제12조 (개인정보 처리방침의 변경)',
    p: [
      '본 방침은 법령·서비스 변경에 따라 개정될 수 있으며, 변경 사항은 서비스 내 공지를 통해 시행 7일 전부터 안내합니다. 학원 회원에게 불리한 변경은 시행 30일 전부터 안내합니다.',
    ],
  },
];

const AppPrivacyPage = () => {
  const navigate = useNavigate();
  const { role } = useParams();
  const isAcademy = role === 'academy';
  const sections = isAcademy ? ACADEMY_PRIVACY : PARENT_PRIVACY;
  const title = isAcademy ? '개인정보 처리방침 (학원용)' : '개인정보 처리방침 (학부모용)';

  return (
    <Container>
      <Header>
        <BackBtn onClick={() => navigate(-1)} aria-label="뒤로 가기">
          <IoChevronBack size={24} />
        </BackBtn>
        <Title>{title}</Title>
      </Header>

      <Content>
        <Lead>
          {SERVICE}는 {isAcademy ? '학원 회원' : '학부모 회원과 자녀'}의 개인정보를
          안전하게 보호하기 위해 최선을 다합니다.
        </Lead>

        {sections.map((s) => (
          <Section key={s.h}>
            <H2>{s.h}</H2>
            {s.p.map((line, i) => <P key={i}>{line}</P>)}
          </Section>
        ))}

        <Footer>
          <FooterText>운영사: {COMPANY}</FooterText>
          <FooterText>문의: {CONTACT}</FooterText>
          <FooterText>시행일: {EFFECTIVE}</FooterText>
        </Footer>
      </Content>
    </Container>
  );
};

export default AppPrivacyPage;

const Container = styled.div`
  background: #fff;
  min-height: 100vh;
  padding-bottom: 80px;
`;

const Header = styled.div`
  position: sticky;
  top: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  background: #fff;
  border-bottom: 1px solid #E5E7EB;
`;

const BackBtn = styled.button`
  color: #111;
  background: transparent;
`;

const Title = styled.p`
  font-size: 17px;
  font-weight: 700;
  color: #111827;
`;

const Content = styled.div`
  max-width: 480px;
  margin: 0 auto;
  padding: 20px 18px;
`;

const Lead = styled.p`
  font-size: 14px;
  line-height: 1.7;
  color: #374151;
  background: #F4F7FF;
  padding: 14px 16px;
  border-radius: 12px;
  margin-bottom: 24px;
`;

const Section = styled.div`
  margin-bottom: 26px;
`;

const H2 = styled.h2`
  font-size: 15.5px;
  font-weight: 800;
  color: #111827;
  margin-bottom: 10px;
`;

const P = styled.p`
  font-size: 13.5px;
  color: #374151;
  line-height: 1.85;
  word-break: keep-all;
  margin-bottom: 4px;
`;

const Footer = styled.div`
  margin-top: 32px;
  padding-top: 16px;
  border-top: 1px solid #E5E7EB;
`;

const FooterText = styled.p`
  font-size: 12.5px;
  color: #6B7280;
  line-height: 1.7;
`;
